<template>
  <div v-if="rotas.length">
    <v-divider class="py-0"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense flat color="tertiary">
            <v-toolbar-title class="custon-toolbar-title">Listagem de Rotas</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text class="py-0">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Rota
                  </th>
                  <th class="text-left">
                    Descrição
                  </th>
                  <th width="8%" class="text-center">
                    Distância
                  </th>
                  <th width="8%" class="text-center">
                    Ativo?
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in rotas" :key="item.id">
                  <td>{{ item.nome }}</td>
                  <td>{{ item.descricao }}</td>
                  <td class="text-center">{{ item.distancia_km }} km</td>
                  <td class="text-center">
                    <v-icon :color="item.ativo ? 'green' : 'red'" small>
                      {{ item.ativo ? 'mdi-check' : 'mdi-close' }}
                    </v-icon>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'VeiculoLotacaoTable',
  data: () => ({}),
  computed: {
    ...mapState('veiculo', ['data']),
    rotas() {
      return this.data.rotas || [];
    },
  },
};
</script>
